import { css } from '@emotion/react';
import {
  useEffect, useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { OverlayLoaderComponent } from '~/_shared/components/overlay/overlayLoader.component';
import { MapContextHoldingPageContainer } from '~/app/maptiveApp/mapContextHoldingPage.container';
import { loadDevExportReportSnapshot } from '~/exportReport/printPage/devExportReportPrintPage.helpers';
import { ExportReportPrintPageContainer } from '~/exportReport/printPage/exportReportPrintPage.container';
import { ExportReportPrintPageLoaderContext } from '~/exportReport/printPage/exportReportPrintPageWrapper.component';
import { useAreMapSettingsReadySelector } from '~/store/mapSettings/ready/mapSettingsReady.selectors';
import {
  exportReportEnable, exportReportSetSettings,
} from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.actionCreators';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';

const loaderStyle = css({
  position: 'fixed',
});

const messageStyle = css({
  padding: '16px 12px',
});

// Development-only replacement of the BE print flow: instead of the BE applying the export report settings
// to a shared map, the snapshot saved from the preview modal is applied locally once the map settings are loaded.
export const DevExportReportPrintPageContainer = () => {
  const dispatch = useDispatch();
  const mapId = useMapIdSelector();
  const areMapSettingsReady = useAreMapSettingsReadySelector();
  const { isActive } = useToolsStateExportReportSelector();
  const [isSnapshotMissing, setIsSnapshotMissing] = useState(false);

  useEffect(() => {
    // Map settings fetch replaces the whole toolsState, so the snapshot can only be applied after it.
    if (mapId === null || !areMapSettingsReady || isActive) {
      return;
    }

    const snapshot = loadDevExportReportSnapshot(mapId);
    if (!snapshot) {
      setIsSnapshotMissing(true);
      return;
    }

    // Enabling the report resets the sample settings, so the settings have to be set afterwards.
    dispatch(exportReportEnable(snapshot.params));
    dispatch(exportReportSetSettings(snapshot.settings));
  }, [areMapSettingsReady, dispatch, isActive, mapId]);

  if (isSnapshotMissing) {
    return (
      <div css={messageStyle}>
        {`No export report snapshot found for map ${mapId}. Open this page from the report preview first.`}
      </div>
    );
  }

  return (
    <ExportReportPrintPageLoaderContext.Provider value>
      <MapContextHoldingPageContainer>
        {() => <ExportReportPrintPageContainer />}
      </MapContextHoldingPageContainer>

      {!isActive && <OverlayLoaderComponent css={loaderStyle} />}
    </ExportReportPrintPageLoaderContext.Provider>
  );
};
